import React from "react";
import CustomExpandableTable from "../../../../components/table/CustomExpandableTable";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import NotInformation from "../../../../components/NotInformation";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import ZoneAccessTableApp from "../Functionality/ZoneAccessTableApp";

/**
 * Zone access tab of the guards module.
 */
const ZoneAccessTable = ({
    selectedList, setSelectedList, modified, setModified, setDeleteModal, goCreate,
    searchElement, setSearchElement, setSearch, setBodyForExport, setCriteria, finalArray,
}) => {
    const {
        t,
        results,
        setResults,
        setSimpleSearch,
        option,
        searchId,
        columns,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        renderOptionsMenu,
        renderExpandedRow,
        handleRowExpand,
        canUpdate,
        canDelete,
        canCreate,
    } = ZoneAccessTableApp({
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setDeleteModal,
        searchElement,
        setBodyForExport,
        setCriteria,
        finalArray,
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
            />

            {results?.content?.length > 0 ?
                <>
                    <CustomExpandableTable
                        id={'tbl_zal_zone_access'}
                        columns={columns}
                        rows={results.content}
                        renderExpandedRow={renderExpandedRow}
                        renderOptionsMenu={renderOptionsMenu}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        checkbox={canDelete}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
                </>
                :
                <NotInformation card={true} className={"mt-4"} text={typeof results?.content === "undefined" ? t('loading') : undefined}>
                    {typeof results?.content !== "undefined" &&
                        <>
                            <div className={"warning-text"}>
                                <p>{t("no_zone_access_created_yet")}</p>
                            </div>
                            {canCreate &&
                                <CustomButtonLink
                                    splitName={false}
                                    id={'btn_zal_create'}
                                    card={true}
                                    onClick={goCreate}
                                    name={'create_new_zone_access'}
                                />
                            }
                        </>
                    }
                </NotInformation>
            }
        </>
    );
};

export default ZoneAccessTable;
